// cart-upsell-tracking.js
document.addEventListener('submit', function (e) {
  const form = e.target.closest('[data-upsell-form]');
  if (!form) return;

  e.preventDefault();

  const variantId = form.dataset.variantId;
  const productName = form.closest('.cart-item')
    ?.querySelector('.cart-item__name')?.textContent.trim();
  const price = parseFloat(form.dataset.price || 0);
  const quantity = parseInt(form.querySelector('[name="quantity"]')?.value || 1, 10);

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(res => {
    if (!res.ok) throw new Error('Add to cart failed');
    return res.json();
  })
  .then(() => {
    if (typeof gtag === 'function') {
      gtag('event', 'add_to_cart', {
        currency: 'CAD',
        value: price * quantity,
        item_list_name: 'cart_page_upsell',
        items: [{ item_id: variantId, item_name: productName, price, quantity }]
      });
    }
    if (window.Shopify && Shopify.analytics) {
      Shopify.analytics.publish('upsell_added', { variantId, productName, price, quantity });
    }
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  })
  .catch(err => console.error('Upsell add failed:', err));
});